import { render, staticRenderFns } from "./ElectronicDocumentsPDF.vue?vue&type=template&id=3c8aeebe&scoped=true"
import script from "./ElectronicDocumentsPDF.vue?vue&type=script&lang=js"
export * from "./ElectronicDocumentsPDF.vue?vue&type=script&lang=js"
import style0 from "./ElectronicDocumentsPDF.vue?vue&type=style&index=0&id=3c8aeebe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8aeebe",
  null
  
)

export default component.exports